import { Component, OnInit, ViewEncapsulation,ElementRef, ViewChild, Optional, Inject } from '@angular/core';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {MatAutocompleteSelectedEvent, MatAutocomplete} from '@angular/material/autocomplete';
import {MatChipInputEvent} from '@angular/material/chips';
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiService } from 'src/app/api.service';
import { Router } from '@angular/router';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatStepper } from '@angular/material/stepper';

@Component({
  selector: 'app-new-poll',
  templateUrl: './new-poll.component.html',
  styleUrls: ['./new-poll.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NewPollComponent implements OnInit {
  allGroups = [];
  newPollData = new FormGroup({
    name: new FormControl('', Validators.required),
    description: new FormControl(''),
    message: new FormControl('', Validators.required),
    pollType: new FormControl('', Validators.required),
    allowVoteChange: new FormControl('', Validators.required),
    adhoc: new FormControl(''),
    isLive: new FormControl(''),
    close_message: new FormControl(''),
    optIn: new FormControl(''),
    group: new FormControl('{}'),
    expTime: new FormControl('',Validators.required)
  });
  time={};
  expTime;
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  pollTypes = ['poll','quiz','elections','ranked-choice'];
  selectedPollType = 'quiz';
  allowVote = false;
  adhoc= false;
  livePoll = false;
  optIn = false;
  myDatePicker;
  myDate = new Date();
  pollInfo;

  options=[{Name:'',showInput:false,Description:'',replayValues:[],id:'',group:null},
  {Name:'',showInput:false,Description:'',replayValues: [],id:'',group:null},
  ];
  optionList;
  correctOptionId;
  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes: number[] = [ENTER, COMMA];

  sections = [];
  selectedSections = [];
  // replayValues = [];
  @ViewChild('stepper') stepper: MatStepper;
  constructor(
    private _formBuilder: FormBuilder,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar,
    private router:Router) {
      this.newPollData.controls['expTime'].setValue('00:00');
  }

  ngOnInit(): void {
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this._apiService.getGroupList().subscribe(res => {
      if (res) {
        this.allGroups = res;
        console.log('allgroups',res);
      }
    },
    (error)=>{
      console.log(error);
    });

    this._apiService.getbmList().subscribe(res => {
      if (res) {
        this.sections = res;
        console.log(this.sections);
      }
    },
    (error)=>{
      console.log(error);
    });
 

  }
  

  addSection(event) {
    if (event && event.option) {
      const id = event.option.value._id;
      this.selectedSections.push(event.option.value);
      this.sections.splice(this.sections.indexOf(event.option.value), 1);
    }
  }

  removeSelectedSection(selectedSection) {
    this.selectedSections.splice(this.selectedSections.indexOf(selectedSection), 1);
    this.sections.push(selectedSection);
  }

  createNewPoll(){
    let memberIdList = [];

    if (this.newPollData.valid) {
      let memberIdList = [];

      for (let i = 0; i < this.selectedSections.length; i++) {
        memberIdList.push(this.selectedSections[i].id);
      }
      let time = this.newPollData.get('expTime').value;
      let timeInsec = time.split(':')[0]*3600 + time.split(':')[1]*60;
      this.selectedPollType = this.newPollData.get('pollType').value;
      let pollData ;
      if(this.adhoc){
        pollData = {
          name: this.newPollData.get('name').value,
          description: this.newPollData.get('description').value,
          message: this.newPollData.get('message').value,
          poll_type: this.newPollData.get('pollType').value,
          allow_vote_change: this.newPollData.get('allowVoteChange').value,
          group_id: '',
          adhoc: this.newPollData.get('adhoc').value,
          is_live: this.newPollData.get('isLive').value,
          expiry_time: timeInsec,
          members:memberIdList,
          is_optin: this.newPollData.get('optIn').value,
          closing_message: this.newPollData.get('close_message').value,
        }
      }else {
        pollData = {
          name: this.newPollData.get('name').value,
          description: this.newPollData.get('description').value,
          message: this.newPollData.get('message').value,
          poll_type: this.newPollData.get('pollType').value,
          allow_vote_change: this.newPollData.get('allowVoteChange').value,
          group_id: this.newPollData.get('group').value.id,
          adhoc: this.newPollData.get('adhoc').value,
          is_live: this.newPollData.get('isLive').value,
          expiry_time: timeInsec,
          members:'',
          is_optin: this.newPollData.get('optIn').value,
          closing_message: this.newPollData.get('close_message').value,
        }
      }
      if(this.pollInfo){
        pollData.id = this.pollInfo.id;
        let updateType = 'new';
        this.updatePoll(pollData,updateType);

      }else{
        this._apiService.createNewPoll(pollData).subscribe(res => {
          console.log('poll data',pollData)
          if (res) {
            console.log(res);
            this.pollInfo = res;
            this._snackBar.open('Poll created', 'OK', { duration: 3000 });
          } 
        },
        (error)=>{
          console.log(error);
        });
      }

    }


    
    
  }


  handleAdd(){
    let instance={Name:'',showInput:true,Description:'',replayValues: [],id:'',group:null};
    this.options.splice(this.options.length,0,instance);
    console.log(this.options)
  }

  handleCancel(index){
    if(this.options.length >2){
      this.options.splice(index,1);
    }else{
      this._snackBar.open('The options count cannot be less than two.', 'OK', { duration: 3000 })
    }
    
  }

  handleSavePollOptions(){
      let pollOption =[];
      let pollOptionInstance = {}
      for (let i = 0; i < this.options.length; i++){
        if(this.options[i].Name && this.options[i].Description && this.options[i].replayValues.length > 0){
          if(this.pollInfo.is_optin && this.options[i].group){
            pollOptionInstance = {
              "name":this.options[i].Name,
              "description":this.options[i].Description,
              "option_type":this.pollInfo.poll_type,
              "poll_id":this.pollInfo.id,
              "group_id": this.options[i].group.id,
              "id":this.options[i].id,
              "similar":this.options[i].replayValues
            }
          }else {
            pollOptionInstance = {
              "name":this.options[i].Name,
              "description":this.options[i].Description,
              "option_type":this.pollInfo.poll_type,
              "poll_id":this.pollInfo.id,
              "id":this.options[i].id,
              "similar":this.options[i].replayValues
            }
          }
          pollOption.push(pollOptionInstance);
        }else if(this.selectedPollType = 'ranked-choice'){
          pollOptionInstance = {
            "name":this.options[i].Name,
            "description":'ranked-choice',
            "option_type":this.pollInfo.poll_type,
            "poll_id":this.pollInfo.id, 
            "id":this.options[i].id,
            "similar":this.options[i].replayValues
          }
          pollOption.push(pollOptionInstance);
        }else{
          pollOption = [];
          this._snackBar.open('First fill all the inputs then try to create option.', 'OK', { duration: 3000 })
          return;
        }
          
      }
      this.stepper.next();
      this.updatePollOption(pollOption);

  }

  updatePollOption(data){
    
    this._apiService.addPollOptions(data).subscribe(res => {
      if (res) {
        console.log(res);
        this.optionList = res;
        this.options = [];
        for(let i = 0; i < this.optionList.length; i++){
          if(this.optionList[i].group_id){
            let geoupInOption = this.allGroups.filter(e => e.id === this.optionList[i].group_id)[0];
            this.options.push({Name:this.optionList[i].name,showInput:false,Description:this.optionList[i].description,replayValues:this.optionList[i].similar,id:this.optionList[i].id,group:geoupInOption});
          }else {
            this.options.push({Name:this.optionList[i].name,showInput:false,Description:this.optionList[i].description,replayValues:this.optionList[i].similar,id:this.optionList[i].id,group:null});
          }
          
        }
        this._snackBar.open('Poll Options added successfully', 'OK', { duration: 3000 });
        if(this.selectedPollType == 'poll' || this.selectedPollType == 'elections' || this.selectedPollType == 'ranked-choice'){
          this.router.navigate(['home/execute'])
          .then(() => {
            window.location.reload();
          });
        }
      }
    },
    (error)=>{
      console.log(error);
    });
  }


  onRadioButtonValueChange(id){
    this.correctOptionId = id;
  }
  

  updatePollsWithCorrectOption(){
    let correctOptionInfo = {
      name: this.pollInfo.name,
      description: this.pollInfo.description,
      message: this.pollInfo.message,
      poll_type: this.pollInfo.poll_type,
      allow_vote_change: this.pollInfo.allow_vote_change,
      group_id: this.pollInfo.group_id,
      adhoc: this.pollInfo.adhoc,
      expiry_time: this.pollInfo.expiry_time,
      members:this.pollInfo.members,
      correct_option: this.correctOptionId,
      id:this.pollInfo.id,
      is_live: this.pollInfo.is_live,
      is_optin: this.pollInfo.is_optin,
      closing_message: this.pollInfo.closing_message
    }
    let updatrType = 'pollOption';
    console.log('correctOptionInfo',correctOptionInfo)
    this.updatePoll(correctOptionInfo,updatrType);
  }

  updatePoll(data,type){

    this._apiService.updatePolls(data).subscribe(res => {
      if (res) {
        this.pollInfo = res;
        console.log(res);
        if(type == 'pollOption'){
          this.router.navigate(['home/execute'])
          .then(() => {
            window.location.reload();
          });
        }
        
        // this.router.navigateByUrl('home/board-member', { skipLocationChange: true })
        // .then(() => {this.router.navigate(['home/execute']);}); 
      } 
    },
    (error)=>{
      console.log(error);
    });
  }

  add(event: MatChipInputEvent, index): void {
    const input = event.input;
    const value = event.value;

    if ((value || '').trim()) {
      let instance = this.options[index].replayValues;
      instance.push(value.trim());
      this.options[index].replayValues = instance;
    }

    // Reset the input value
    if (input) {
      input.value = '';
    }
  }

  remove(replayIndex,index): void {
    let instance = this.options[index].replayValues;
    instance.splice(replayIndex,1);
    this.options[index].replayValues = instance;
  }
}
